import { Link } from "react-router-dom";
import Shell from "@/components/app/Shell";
import { Heart, ArrowLeft, BookOpen, ArrowRight } from "lucide-react";

export default function FellOff() {
  return (
    <Shell>
      <Link to="/dashboard" className="inline-flex items-center gap-2 text-sm text-ink-mid mb-6"><ArrowLeft size={14} /> Back</Link>
      <div className="max-w-2xl mx-auto bg-warm-white border border-edge rounded-3xl p-8 md:p-12" data-testid="fell-off-screen">
        <div className="w-14 h-14 rounded-full bg-mauve-pale flex items-center justify-center">
          <Heart className="text-mauve" size={24} />
        </div>
        <h1 className="font-display text-3xl font-bold text-navy mt-6">You're not behind. You're here.</h1>
        <p className="text-ink-mid mt-4 leading-relaxed">
          Every family pauses. Life happens — travel, school, illness, hard weeks. Stepping away from the work does not undo the work.
        </p>
        <div className="mt-8 space-y-4">
          <div className="rounded-2xl bg-cream border border-edge p-5">
            <div className="text-xs uppercase tracking-widest text-mauve font-bold">Pick up where you left off</div>
            <p className="text-sm text-ink-dark mt-2 leading-relaxed">
              When you come back, resume the session you were on — <b>never restart from Session 1</b>. Your child's muscles remember more than you'd think. Give a week of gentle practice at the current session before deciding to move forward.
            </p>
          </div>
          <div className="rounded-2xl bg-cream border border-edge p-5">
            <div className="text-xs uppercase tracking-widest text-gold font-bold">Reset your rhythm, not the plan</div>
            <p className="text-sm text-ink-dark mt-2 leading-relaxed">
              Try attaching practice to something already daily — brushing teeth, breakfast, or bedtime story. Two minutes counts. A single log counts.
            </p>
          </div>
          <div className="rounded-2xl bg-cream border border-edge p-5">
            <div className="text-xs uppercase tracking-widest text-navy font-bold">Progress, not perfection.</div>
            <p className="text-sm text-ink-dark mt-2 leading-relaxed">
              This program is designed to hold your family gently. Missed days are part of it. Your child does not need to be perfect at any of this — they only need to keep coming back.
            </p>
          </div>
        </div>

        {/* Motivation & re-engagement resource — same combined PDF + video the parent can find
            under Learn and Support. Placed here because "how do I get my kid excited again"
            is the natural next question after "we fell off." */}
        <Link
          to="/learn/parent-playbook"
          data-testid="fell-off-parent-playbook-link"
          className="mt-6 flex items-start gap-3 p-5 rounded-2xl bg-mauve-pale border-2 border-mauve/40 hover:border-mauve transition-all"
        >
          <div className="w-10 h-10 rounded-xl bg-mauve text-warm-white flex items-center justify-center shrink-0">
            <BookOpen size={18} />
          </div>
          <div className="flex-1 min-w-0">
            <div className="text-[10px] uppercase tracking-[0.2em] text-mauve font-bold">Bonus resource</div>
            <div className="font-display font-bold text-navy mt-0.5">Myo Parent Playbook</div>
            <p className="text-xs text-ink-mid mt-1 leading-relaxed">Fun ideas, games, and strategies for getting your child excited and cooperative when they've lost the spark.</p>
          </div>
          <ArrowRight className="text-mauve shrink-0 mt-1" size={18} />
        </Link>

        <div className="mt-8 flex gap-3 flex-wrap">
          <Link to="/dashboard" className="inline-flex items-center gap-2 bg-gold text-ink-dark px-6 py-3 rounded-full font-semibold hover:bg-gold-light" data-testid="fell-off-back-to-dashboard">Back to home</Link>
        </div>
      </div>
    </Shell>
  );
}
